module.exports = __webpack_public_path__ + "static/media/floor_e2.9dc6de01.png";